import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ReturnFormPage from "./ReturnFormPage";
import ReturnListPage from "./ReturnListPage";
import { ReturnProvider } from "../../store/returnContext";
import { ProductProvider } from "../../store/productContext";
import { CustomerProvider } from "../../store/customerContext";
import { CurrencyProvider } from "../../store/currencyContext";

const ReturnIndex: React.FC = () => (
    <ProductProvider>
        <CustomerProvider>
            <CurrencyProvider>
                <ReturnProvider>
                    <Routes>
                        <Route path="form" element={<ReturnFormPage />} />
                        <Route path="form/:id" element={<ReturnFormPage />} />
                        <Route path="list" element={<ReturnListPage />} />
                        <Route index element={<Navigate to="list" replace />} />
                        <Route path="*" element={<Navigate to="list" />} />
                    </Routes>
                </ReturnProvider>
            </CurrencyProvider>
        </CustomerProvider>
    </ProductProvider>
);

export default ReturnIndex;
